import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import ScrollToTop from './ScrollToTop';
import { CookieConsentProvider } from './CookieConsent';

export default function Layout() {
  useEffect(() => {
    // Load Zuri Chat Widget with Zyra AI
    const script = document.createElement('script');
    script.src = 'https://media.getzurihub.com/widget.js';
    script.async = true;
    
    const configScript = document.createElement('script');
    configScript.innerHTML = `
      window.zuriChatConfig = {
        workspaceId: 'ws_mr9ll0xx_1ctlv5zs',
        position: 'bottom-right',
        color: '#0518a8',
        headerColor: '#042395',
        enableAI: true,
        aiModel: 'gpt-4o-mini',
      };
    `;
    
    document.head.appendChild(configScript);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(configScript);
      document.head.removeChild(script);
    };
  }, []);

  return (
    <CookieConsentProvider>
      <div className="flex min-h-screen flex-col">
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </CookieConsentProvider>
  );
}
